import { Outlet } from 'react-router-dom';
import { useState } from 'react';

// mantine
import { AppShell } from '@mantine/core';

// project imports
import PreviewHeader from './components/PreviewHeader';
import KayakSearchButton from 'ui-components/buttons/KayakSearchButton';
import KayakDialog from 'ui-components/dialogs/KayakDialog';
import { semanticColors, zIndex as zIndexTokens } from 'theme';

// ==============================|| PREVIEW LAYOUT ||============================== //

const PreviewLayout = () => {
  const [openKayakDialog, setOpenKayakDialog] = useState(false);

  return (
    <AppShell
      header={{ height: { base: 56, md: 80 } }}
      padding="md"
      styles={{
        header: {
          backgroundColor: semanticColors.surface.base,
          borderBottom: '1.5px solid var(--mantine-color-coral-6)',
          zIndex: zIndexTokens.sticky
        },
        main: {
          backgroundColor: semanticColors.surface.base
        }
      }}
    >
      <AppShell.Header>
        <PreviewHeader />
      </AppShell.Header>
      <AppShell.Main>
        <Outlet />
        <KayakSearchButton goOpenKayakDialog={() => setOpenKayakDialog(true)} />
        <KayakDialog open={openKayakDialog} onClose={() => setOpenKayakDialog(false)} />
      </AppShell.Main>
    </AppShell>
  );
};

export default PreviewLayout;
